import {ModuleProto} from "../module-proto";
import {ModuleType} from "../types";
import {SettingsMenuTopCategory} from "../settings-module";
import {SettingsParentSection} from "../../../app/settings/const";
import moduleClockInOut_initCustomView from "./actions/init-custom-view";

// const debug = "ClockModule"
const debug = false

export class ModuleClockInOut extends ModuleProto {

    public editDuration     : any
    public takeGeoData      : any

    constructor(moduleConfig: JSONObject) {
        super(ModuleType.CLOCK_IN_OUT, moduleConfig);

        debug && console.log(debug, "constructor() moduleConfig=", moduleConfig)

        this.name                    = "Clock-in/Clock Out"

        this.description             = "The Clock In/Out module provides a streamlined solution for tracking work hours and attendance. Users can easily clock in and out directly within the platform, allowing for accurate records of their working hours. "
        this.svgIcon                 = "isvg-clock-in-out2"
        this.settingsMenuTopCategory = SettingsMenuTopCategory.ORGANIZATION
        this.typeLabel               = "Attendance tracking"
        this.settingsUrl             = "settings/clock-in-out"

        this.parentSection          = SettingsParentSection.COMPANY_USERS

        this.editDuration           = _.get(moduleConfig, 'editDuration', 1)
        this.takeGeoData            = _.get(moduleConfig, 'takeGeoData', true)

    }


    // do not make it ()=>{} it will make it an instance method but we need inheritance (!)
    enable() {
        super.enable()

        // patch dynamic custom views
        moduleClockInOut_initCustomView()

        gd.layout.navigation.reset()
        gd.layout.navigation.reRender("Module clock in out enabled / disabled")
    }

    disable():void {
        super.disable()

        // patch dynamic custom views
        moduleClockInOut_initCustomView()

        gd.layout.navigation.reset()
        gd.layout.navigation.reRender("Module clock in out enabled / disabled")
    }

    toJson() {
        const result = super.toJson();

        result.editDuration  = this.editDuration
        result.takeGeoData   = this.takeGeoData

        return result
    }

}
